import FineReimbursementResource from "./fineReimbursement.resource";

const fineReimbursementModule = angular
  .module("app.resources.fineReimbursement", [])
  .service("FineReimbursement", FineReimbursementResource);

export default fineReimbursementModule;



// WEBPACK FOOTER //
// ./src/resources/fineReimbursement/fineReimbursement.module.js